/**
 * @method: to call reducer
 */
import { actionType } from "../articleDetail/action";
import defaultState from '../../../store/defaultStore';
let defaultStore = defaultState.articleDetail;

const reducer = (state = defaultStore, action) => {

     switch (action.type) {
          case actionType.ARTICLE_DETAIL_REQUEST:
               state = { ...state };
               break;
          case actionType.ARTICLE_DETAIL_RESPONSE:

               state = {
                    ...state,
                    pageData: action.payload
               };

               break;
          case actionType.ARTICLE_DETAIL_API_REQUEST:
               state = { ...state };
               break;
          case actionType.ARTICLE_DETAIL_API_SUCCESS:
               state = {
                    ...state,
                    article: action.payload
               };
               break;
          case actionType.ARTICLE_DETAIL_API_FAILURE:
               state = {
                    ...state,
                    article: action.payload
               };
               break;


          // to save user feedback response

          case actionType.FB_API_REQUEST:
               state = { ...state };
               break;
          case actionType.FB_API_SUCCESS:
               state = {
                    ...state,
                    FBRes: action.payload
               };

               break;
          case actionType.FB_API_FAILURE:

               state = {
                    ...state,
                    FBRes: action.payload
               };
               break;

          case actionType.ACCESS_FP_API_REQUEST:
               state = { ...state };                
               break;
               
          case actionType.ACCESS_FP_API_SUCCESS:
                
               state = {
                    ...state,
                    accessLogResp: action.payload.data
               };          
               
               break;

               case actionType.ACCESS_FP_UPDATE_API_REQUEST:
                    state = { ...state };              
                    break;
               case actionType.ACCESS_FP_UPDATE_API_SUCCESS:
                     
                    state = {
                         ...state,
                         accessLogResp: action.payload.data
                    };          
                   
                    break;


          default:
               state = { ...state };
               break;
     }
     return state;
};
export default reducer;